/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import * as S from './GeneralModalUI.styled';
import { EmptyIcon, PictureIcon, VideoIcon } from 'assets/icons';
import { ImageWithFallback, ParagraphWithTooltip } from 'components';
import { format } from 'date-fns';
import { getVideoSrc } from 'utils';

const creativeNameStyle = {
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
};

export const ListItem = ({ selectedImgOrVideo$, item, searchValue$, isImg, isVideo }) => {
  const videoSrc = useMemo(() => getVideoSrc(item), [item]);

  return (
    <S.CreativeItem
      onClick={() => (selectedImgOrVideo$.value = item)}
      isSelected={selectedImgOrVideo$.value.media_id === item.media_id}
    >
      {isImg && (
        <>
          <PictureIcon />
          <ImageWithFallback
            key={item.media_id}
            width='32px'
            height='32px'
            src={`https://cdn.appnext.com/banner/${item.file_name}`}
            //fallbackSrc={EmptyIcon}
          />
        </>
      )}
      {isVideo && (
        <>
          <VideoIcon />
          <video style={{ width: '32px', height: '32px' }} src={videoSrc} />
        </>
      )}
      <ParagraphWithTooltip
        text={item.file_name || item.name || 'no file name'}
        style={creativeNameStyle}
        isHighlight
        search={searchValue$.value}
      />
      <S.DateBox>{format(new Date(item.upload_date), 'dd/MM/yyyy')}</S.DateBox>
    </S.CreativeItem>
  );
};
